import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { translate } from '@jsverse/transloco';

import { AppService } from 'app/app.service';
import {
  ConfigurationRoute,
  ConfigurationRouteService,
} from 'app/providers/semantria-api/configuration-route.service';
import { ConfigurationService } from 'app/providers/semantria-api/configuration.service';
import { AlertService } from 'app/services/alert.service';
import {
  injectComponentTelemetryService,
  EnableComponentTelemetry,
  EnableClassTelemetry,
} from 'app/services/otel.service';
import { ConfigurationListEntry } from '../configuration-route-configurations/configuration-route-configurations.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-create-configuration-route-drawer',
  templateUrl: './create-configuration-route-drawer.component.html',
  styleUrls: ['./create-configuration-route-drawer.component.scss'],
  standalone: false,
})
export class CreateConfigurationRouteDrawerComponent implements OnInit, OnDestroy {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  @Input() open: boolean;
  @Input() nameValidator: (control: AbstractControl) => { [p: string]: any } | null;
  @Input() groupId: string;
  @Input() canEditRoute: boolean;

  @Output() close = new EventEmitter();

  configurationRoute: ConfigurationRoute;
  routes: ConfigurationRoute[];
  includedConfigurations: ConfigurationListEntry[] = [];
  defaultLanguages: any[];

  isNameValid: boolean;
  isResponseTypeValid = true;
  isSaving: boolean;

  constructor(
    private configurationRouteService: ConfigurationRouteService,
    private configService: ConfigurationService,
    private alertService: AlertService
  ) {
    this.configurationRoute = {
      route_id: undefined,
      name: '',
      response_type: 'POLLING',
      callback_url: '',
      account_id: undefined,
      creation_date: new Date(),
      configuration_map: {},
    };
  }

  ngOnInit(): void {
    AppService.hideBodyOverflow();
  }

  onIncludedConfigurationsChanged($event) {
    this.includedConfigurations = $event;
    this.defaultLanguages = this.includedConfigurations.map((c) => ({
      title: c.languageName,
      id: c.languageId,
    }));
    if (!this.defaultLanguages.some((l) => l.id === this.configurationRoute.default_language_id)) {
      this.configurationRoute.default_language_id = undefined;
    }
  }

  get isValid() {
    return this.isNameValid && this.isResponseTypeValid && this.includedConfigurations.length;
  }

  cancel() {
    this.close.emit();
  }

  async save() {
    this.isSaving = true;

    const configurationRouteDto: ConfigurationRoute = JSON.parse(
      JSON.stringify(this.configurationRoute)
    );

    try {
      configurationRouteDto.configuration_map = this.includedConfigurations.reduce((prev, curr) => {
        if (curr.configurations.length) {
          prev[curr.languageId] = curr.configurations[0].configuration.id;
        }

        return prev;
      }, {});

      const res = await this.configurationRouteService.createConfigurationRoute(
        configurationRouteDto,
        this.groupId
      );
      this.configService.clearCache();

      this.alertService.showToast(
        translate('configuration-routes.create.create-success', {
          route: configurationRouteDto.name,
        })
      );

      this.close.emit(res);
    } catch (err) {
      this.isSaving = false;
      this.alertService.showErrorToast(
        translate('configuration-routes.create.create-failed', {
          route: configurationRouteDto.name,
        }),
        err
      );
    }
  }

  ngOnDestroy() {
    AppService.showBodyOverflow();
  }
}
